import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import Landing from "@/pages/Landing";
import Legal from "@/pages/Legal";
import Panel from "@/pages/Panel";
import Visita from "@/pages/Visita";

const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
};

function App() {
    useEffect(() => {
        const lenis = new Lenis({ duration: 1.15, anchors: true });
        let rafId;
        const loop = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(loop);
        };
        rafId = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
        };
    }, []);

    return (
        <div className="App">
            <BrowserRouter>
                <ScrollToTop />
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/aviso-legal" element={<Legal page="aviso-legal" />} />
                    <Route path="/privacidad" element={<Legal page="privacidad" />} />
                    <Route path="/cookies" element={<Legal page="cookies" />} />
                    <Route path="/panel" element={<Panel />} />
                    <Route path="/visita" element={<Visita />} />
                    <Route path="*" element={<Landing />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
